import { AddOutlined, DeleteOutline } from "@mui/icons-material";
import { Box, Button, Divider, IconButton } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FieldArray } from "react-final-form-arrays";
import { useDispatch } from "react-redux";
import CreateEditForm from "../components/finalForm/CreateEditForm";
import RffBooleanToggleField from "../components/finalForm/inputs/RffBooleanToggleField";
import RffDateField from "../components/finalForm/inputs/RffDateField";
import RffPercentField from "../components/finalForm/inputs/RffPercentField";
import RffSelectAutocompleteField from "../components/finalForm/inputs/RffSelectAutocompleteField";
import RffSelectField from "../components/finalForm/inputs/RffSelectField";
import RffSelectToggleField from "../components/finalForm/inputs/RffSelectToggleField";
import RffTextField from "../components/finalForm/inputs/RffTextField";
import RffGroup from "../components/finalForm/shared/RffGroup";
import Flx from "../components/layout/Flx";
import Txt from "../components/typography/Txt";
import { selectOptionsEntityType } from "../constants/selectOptions/selectOptionsEntityType";
import { selectOptionsUsaStates } from "../constants/selectOptions/selectOptionsUsaStates";
import { useEndpointHook } from "../hooks/useEndpointHook";
import { profileClear } from "../redux/actions/profileActions";
import { sidebarClose } from "../redux/reducers/sidebarReducer";

const CreateEditBorrowerEntityForm = ({
  isEditing,
  initialValues,
  metadata,
}) => {
  const { loading, createEntityWithOrWithoutFiles, updateBorrowerEntity } =
    useEndpointHook();
  const dispatch = useDispatch();

  const onCreate = (formData) => {
    createEntityWithOrWithoutFiles({
      data: formData,
      onSuccessFn: (d) => {
        dispatch(profileClear());
        // handleCreateLoanSuccess();
      },
    });
  };

  const onUpdate = (formData) => {
    console.log("onUpdate", {
      entityId: initialValues?._id,
      data: formData,
      onSuccessFn: (d) => {
        dispatch(profileClear());
        dispatch(sidebarClose());
        // handleCreateLoanSuccess();
      },
    });
    // return;
    updateBorrowerEntity({
      entityId: initialValues?._id,
      data: formData,
      onSuccessFn: (d) => {
        dispatch(profileClear());
        dispatch(sidebarClose());
        // handleCreateLoanSuccess();
      },
    });
  };

  if (isEditing) {
    return (
      <CreateEditForm
        onUpdate={onUpdate}
        loading={loading}
        initialValues={initialValues}
        updateButtonText="Update Entity"
      >
        <CreateEntityFormQuestions />
      </CreateEditForm>
    );
  }
  return (
    <CreateEditForm
      onCreate={onCreate}
      loading={loading}
      createButtonText="Create Entity"
    >
      <CreateEntityFormQuestions />
    </CreateEditForm>
  );
};

const CreateEntityFormQuestions = ({ disabled }) => {
  return (
    <Flx column g={4}>
      <RffGroup suppressBottomMargin>
        <RffTextField
          disabled={disabled}
          name="entityName"
          label="Entity Name"
        />
        {/* <RffBooleanToggleField
          disabled={disabled}
          name="borrowerEntity"
          label="Is this entity a borrower on the loan?"
        /> */}
        <RffPercentField
          disabled={disabled}
          name="applicantEntityPercentOwnership"
          label="What percentage ownership of the entity does the borrower have?"
        />
        <RffSelectAutocompleteField
          disabled={disabled}
          size={4}
          name="entityStateOfOrganization"
          label="Entity State Of Organization"
          options={selectOptionsUsaStates}
        />
        <RffSelectField
          name="entityType"
          size={4}
          disabled={disabled}
          label="Entity Type"
          options={selectOptionsEntityType}
        />
        <RffDateField
          size={4}
          disabled={disabled}
          name="entityOrganizationDate"
          label="Entity Organization Date"
        />
      </RffGroup>
      <Divider sx={{ my: 2, borderColor: grey[200] }} />
      {/* Entity Members Section */}
      <FieldArray name="entityMembers">
        {({ fields }) => (
          <Box sx={{ width: "100%" }}>
            <Flx fw ac wrap jb g={1} sx={{ mb: 2 }}>
              <Flx column>
                <Txt bold>Entity Members</Txt>
                <Txt secondary>Add members or managers of this entity.</Txt>
              </Flx>
              <Button
                disabled={disabled}
                variant="outlined"
                startIcon={<AddOutlined />}
                onClick={() =>
                  fields.push({
                    firstName: "",
                    lastName: "",
                    middleName: "",
                    fullName: "",
                    entityPercentOwnership: 0,
                    isGuarantor: false,
                    title: "",
                  })
                }
                //   sx={{ mt: 1, m: "0 auto" }}
              >
                Add Entity Member
              </Button>
            </Flx>
            {fields.map((name, index) => (
              <Box
                key={name}
                sx={{
                  mb: 2,
                  border: `1px solid ${grey[300]}`,
                  borderRadius: 2,
                  position: "relative",
                }}
              >
                <Flx
                  fw
                  jb
                  sx={{
                    mb: 2,
                    px: 2,
                    py: 1.5,
                    //   background: grey[50],
                    borderBottom: `1px solid ${grey[200]}`,
                  }}
                >
                  <Txt sx={{ fontStyle: "italic" }} bold>
                    Member {index + 1}
                  </Txt>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => fields.remove(index)}
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                    }}
                  >
                    <DeleteOutline fontSize="small" />
                  </IconButton>
                </Flx>

                <RffGroup gap={2} sx={{ p: 2 }}>
                  <RffTextField
                    disabled={disabled}
                    name={`${name}.firstName`}
                    label="First Name"
                    size={4}
                  />
                  <RffTextField
                    disabled={disabled}
                    name={`${name}.middleName`}
                    label="Middle Name"
                    size={4}
                  />
                  <RffTextField
                    disabled={disabled}
                    name={`${name}.lastName`}
                    label="Last Name"
                    size={4}
                  />
                  <RffPercentField
                    name={`${name}.entityPercentOwnership`}
                    label="Ownership Percentage"
                    //   size={4}
                  />

                  <RffSelectToggleField
                    name={`${name}.title`}
                    size={6}
                    disabled={disabled}
                    label="Title/Role"
                    options={[
                      { label: "Manager", value: "Manager" },
                      { label: "Member", value: "Member" },
                      { label: "Officer", value: "Officer" },
                      { label: "Other", value: "Other" },
                    ]}
                  />
                  <RffBooleanToggleField
                    disabled={disabled}
                    name={`${name}.isGuarantor`}
                    label="Is Guarantor?"
                    size={6}
                  />
                </RffGroup>
              </Box>
            ))}
          </Box>
        )}
      </FieldArray>
      <Divider sx={{ my: 2, borderColor: grey[200] }} />
    </Flx>
  );
};
export default CreateEditBorrowerEntityForm;
